/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import React from 'react';
import DOMPurify from 'dompurify';

interface IProps {
  html: string;
}

const sanitizeHtml = (html: string) => {
  return DOMPurify.sanitize(html, { USE_PROFILES: { html: true } });
};

// TODO: Need to add DOMPurify to sanitize the HTML
function HTMLViewer(props: IProps) {
  const { html } = props;

  const cleanHtml = sanitizeHtml(html);

  return (
    <div
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: cleanHtml
      }}
    />
  );
}

export default HTMLViewer;
